"use strict";
/** Στάδιο πελάτη (CRM pipeline) — κοινό web & mobile. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_STAGE_BADGE_TONES = exports.CUSTOMER_STAGES_PIPELINE = exports.CUSTOMER_STAGE_LABELS = void 0;
exports.formatCustomerStage = formatCustomerStage;
exports.customerStageBadgeTone = customerStageBadgeTone;
exports.customerStageBarClass = customerStageBarClass;
exports.CUSTOMER_STAGE_LABELS = {
    LEAD: 'Επαφή',
    QUALIFIED: 'Επαφή',
    PROPOSAL: 'Προσφορά',
    NEGOTIATION: 'Διαπραγμάτευση',
    WON: 'Αποδοχή',
    LOST: 'Ακύρωση',
};
/** Στάδια που εμφανίζονται σε φίλτρα / funnel (χωρίς QUALIFIED). */
exports.CUSTOMER_STAGES_PIPELINE = [
    'LEAD',
    'PROPOSAL',
    'NEGOTIATION',
    'WON',
    'LOST',
];
exports.CUSTOMER_STAGE_BADGE_TONES = {
    LEAD: 'sky',
    QUALIFIED: 'sky',
    PROPOSAL: 'violet',
    NEGOTIATION: 'amber',
    WON: 'emerald',
    LOST: 'zinc',
};
function formatCustomerStage(stage) {
    var _a;
    return (_a = exports.CUSTOMER_STAGE_LABELS[stage]) !== null && _a !== void 0 ? _a : stage;
}
function customerStageBadgeTone(stage) {
    var _a;
    return (_a = exports.CUSTOMER_STAGE_BADGE_TONES[stage]) !== null && _a !== void 0 ? _a : 'zinc';
}
/** Χρώμα ράβδων γραφήματος (Tailwind). */
function customerStageBarClass(stage) {
    switch (stage) {
        case 'WON':
            return 'bg-emerald-600 dark:bg-emerald-500';
        case 'LOST':
            return 'bg-zinc-400 dark:bg-zinc-500';
        case 'NEGOTIATION':
            return 'bg-amber-500 dark:bg-amber-500';
        case 'PROPOSAL':
            return 'bg-violet-600 dark:bg-violet-500';
        case 'LEAD':
        case 'QUALIFIED':
        default:
            return 'bg-sky-600 dark:bg-sky-500';
    }
}
